import {LanguageSwitcher} from '@/components/shared/headers/Header/LanguageSwitcher';
import {LogoutButton} from '@/components/shared/headers/Header/LogoutButton';
import {UserProfile} from '@/components/shared/headers/Header/UserProfile';
import React, {FC} from 'react';
import SidebarModal from '@/components/core/modal/SidebarModal';
import {HeaderMenu} from '@/components/shared/headers/Header/HeaderMenu';
import HeaderStore from '@/domain/core/HeaderStore';
import User from '@/domain/core/User';
import {useTranslation} from 'react-i18next';
import cn from './style.module.sass';
import {observer} from 'mobx-react-lite';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
  className?: string;
  position?: 'left' | 'right';
  hasActions: boolean;
}

const MenuSidebar: FC<IProps> = observer(({
  isOpen,
  handleClose, handleOpen,
  className,
  position,
  hasActions,
}) => {
  const HeaderStoreInstance = React.useMemo(() => new HeaderStore(User), []);
  const {tabsConfig} = HeaderStoreInstance;
  const {t} = useTranslation();

  return (
    <SidebarModal
      isOpen={isOpen}
      onCloseHandler={() => handleClose()}
      preventCloseOnClickOutside={true}
      className={className}
      position={position}>
      <div className={cn.wrapper}>
        {hasActions && (
          <>
            <div className="flex items-center justify-end gap-5 pt-3">
              <LanguageSwitcher />
              <LogoutButton />
            </div>

            <div className="ml-9">
              <UserProfile hasInfo={true} />
            </div>
          </>
        )}

        <div className={cn.title}>{t('layout.menu')}</div>
        <div className={cn.list}>
          <HeaderMenu menuItems={tabsConfig} orientation={'vertical'} />
        </div>
      </div>
    </SidebarModal>
  );
});

export default MenuSidebar;
